import React from 'react';
import { Table, Icon } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { fetchEvents, createEvent } from '../../actions';
import { hasEvents } from '../helpers/EventUtils';
import TableList from './TableList';

const styles = {
  emptyState: {
    textAlign: 'center',
    padding: '60px 20px',
    color: '#888',
  },
  tableHeader: {
    backgroundColor: '#f9f9f9',
  },
};

class GameResultTable extends React.Component {
  renderEmptyState = () => {
    return (
      <div style={styles.emptyState}>
        <Icon name="inbox" size="huge" style={{ marginBottom: '15px', opacity: 0.5 }} />
        <p>No results available yet</p>
      </div>
    );
  };

  renderResultsTable = () => {
    return (
      <Table basic="very" striped selectable>
        <Table.Header>
          <Table.Row style={styles.tableHeader}>
            <Table.HeaderCell>Date</Table.HeaderCell>
            <Table.HeaderCell>Location</Table.HeaderCell>
            <Table.HeaderCell>Club</Table.HeaderCell>
            <Table.HeaderCell>Detailed Results</Table.HeaderCell>
            <Table.HeaderCell>Hands</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <TableList showRows={this.props.showRows} bridgeEvents={this.props.events} />
      </Table>
    );
  };

  render() {
    return hasEvents(this.props) ? this.renderResultsTable() : this.renderEmptyState();
  }
}

const mapStateToProps = (state) => {
  return { events: state.events };
};

export default connect(mapStateToProps, { fetchEvents, createEvent })(GameResultTable);
